import type { HasPermissionFunction } from '~/modules/auth';
import { FEATURE_FLAGS } from '~/modules/experiments/features';
import { useFeatureFlags } from '~/modules/experiments/hooks/useFeatureFlags';

export enum NavigationPermissionKeys {
  RELEASE_CLINIC = 'RELEASE_CLINIC',
  VIDEO_MANAGEMENT = 'VIDEO_MANAGEMENT',
  REPORTS = 'REPORTS',
  CREATE_RELEASE = 'CREATE_RELEASE',
  SETTINGS = 'SETTINGS',
  WMG_RELEASE_MANAGEMENT = 'WMG_RELEASE_MANAGEMENT',
  WMG_LINEUP = 'WMG_LINEUP',
  WMG_ARTIST_CHANNEL_HEALTH = 'WMG_ARTIST_CHANNEL_HEALTH',
}

export const useHasDdexConsoleAccess = (
  hasPermission: HasPermissionFunction,
) => {
  const [isDdexConsoleEnabled] = useFeatureFlags([
    FEATURE_FLAGS.ContainerDdexConsole,
  ]);

  return isDdexConsoleEnabled && hasPermission('DDEX.VIEW');
};

export const NAVIGATION_PERMISSIONS: Record<
  NavigationPermissionKeys,
  (
    hasPermission: HasPermissionFunction,
    context?: Record<string, unknown>,
  ) => boolean
> = {
  [NavigationPermissionKeys.RELEASE_CLINIC]: (hasPermission) =>
    hasPermission('RELEASE_CLINIC.VIEW_INTEGRATION'),

  [NavigationPermissionKeys.VIDEO_MANAGEMENT]: (hasPermission) =>
    hasPermission('VIDEO_CLAIM.VIEW'),

  [NavigationPermissionKeys.REPORTS]: (hasPermission) =>
    hasPermission('REPORT.VIEW'),
  [NavigationPermissionKeys.CREATE_RELEASE]: (hasPermission) =>
    hasPermission('RELEASE.CREATE'),
  [NavigationPermissionKeys.SETTINGS]: (hasPermission) =>
    hasPermission('USER.VIEW'),
  [NavigationPermissionKeys.WMG_RELEASE_MANAGEMENT]: () => {
    const [isWmgReleaseManagementEnabled] = useFeatureFlags([
      FEATURE_FLAGS.WmgReleaseManagement,
    ]);

    return isWmgReleaseManagementEnabled;
  },
  // @TODO DPAM-1230: combine with hasPermission once the page-access permission lands.
  [NavigationPermissionKeys.WMG_LINEUP]: () => {
    const [isWmgLineupEnabled] = useFeatureFlags([FEATURE_FLAGS.WmgLineup]);

    return isWmgLineupEnabled;
  },
  // @TODO: combine with hasPermission once the Artist Channel Health permission exists.
  [NavigationPermissionKeys.WMG_ARTIST_CHANNEL_HEALTH]: () => {
    const [isWmgArtistChannelHealthEnabled] = useFeatureFlags([
      FEATURE_FLAGS.WmgArtistChannelHealth,
    ]);

    return isWmgArtistChannelHealthEnabled;
  },
};
